import React, { useState } from "react";

import Breadcrumbs from "../../components/Breadcrumbs";
import Layout from "../../components/Layout";
import PixelArt from "../../components/PixelArt";
import { attributesNameMap } from "../../data/attributesNameMap";

const PAGE_SIZE = 20;

const AttributePage = ({ pageContext }) => {
  const [maxDisplayCount, setMaxDisplayCount] = useState(PAGE_SIZE);
  const { attributeKey, allPunks } = pageContext;

  const name = attributesNameMap[attributeKey].name;
  return (
    <Layout seoTitle={`Avocados with Attribute ${name}`}>
      <main>
        <Breadcrumbs text={name} />
        <h1 style={{ marginTop: 0 }}>{name}</h1>
        <h3 style={{ marginTop: 30 }}>{allPunks.length} Avocados Found</h3>
        <div style={{ display: "flex", flexWrap: "wrap" }}>
          {allPunks.slice(0, maxDisplayCount).map((punkID) => {
            return <PixelArt key={punkID} punkID={punkID} size={96} />;
          })}
        </div>
        {maxDisplayCount < allPunks.length && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: 20,
            }}
          >
            <a
              style={{
                textDecoration: "none",
                backgroundImage: "none",
                cursor: "pointer",
                boxShadow: "none",
              }}
              onClick={() => {
                setMaxDisplayCount((prevVal) => prevVal + PAGE_SIZE);
              }}
            >
              Show More
            </a>
          </div>
        )}
      </main>
    </Layout>
  );
};

export default AttributePage;
